import { useTranslation } from 'react-i18next'
import type { ClosedNoticePhase } from '../useStorefrontSchedule.js'

interface Props {
  message: string
  phase: Exclude<ClosedNoticePhase, 'none'>
  onAcknowledge: () => void
}

export default function StorefrontClosedNotice({ message, phase, onAcknowledge }: Props) {
  const { t } = useTranslation()

  if (phase === 'bar') {
    return (
      <>
        <div className="storefront-closed-bar-spacer" aria-hidden="true">{message}</div>
        <div className="storefront-closed-bar" role="status" aria-live="polite">
          {message}
        </div>
      </>
    )
  }

  return (
    <div className="storefront-closed-overlay">
      <div className="storefront-closed-dialog" role="alertdialog" aria-live="assertive">
        <p className="storefront-closed-dialog-text">{message}</p>
        <button
          type="button"
          className="storefront-closed-dialog-btn"
          onClick={onAcknowledge}
          autoFocus
        >
          {t('storefront.closedNoticeAck')}
        </button>
      </div>
    </div>
  )
}
